import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import iconPath from "./../../../helpers/iconHelper";
import {encrypt} from "../../../helpers/CryptoJs"


export default function Carousal(props)  {

  const [index, setIndex]         = React.useState(0);
  const [direction, setDirection] = React.useState(null);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
    setDirection(e.direction);
  };

  return (
    
    <div id="myCarousel" className="carousel slide" data-ride="carousel">
    <div className="carousel-inner">
      { 
        (props.imageList.media_details != undefined) ?
        props.imageList.media_details.map((tile,index) => {  
          return(
            (tile.media_type == 'IMAGE') ? 
            <div className={(props.currentActiveImage == index) ? "item active" : "item" } key={tile.gallery_id}> 
              <img src={tile.media_link} alt="Los Angeles"   
              onError = {(e) => {
                e.target.src = iconPath['BREAKIMAGE']
              }} />

              <div className="modal_actions_icons">
                <div className="col-lg-4">
               
                  <Link to={ (props.imageList.media_details.length == 1) ? `/post/${encrypt(props.feed_id)}` : `/media/${encrypt(tile.gallery_id)}`}>
                    <div className="btn-toolbar">
                    {
                      (props.imageList.media_details.length > 1) ?
                        (tile.my_reaction == '') ?
                        <img width="26px" src={iconPath['DEFAULTREACTION']} /> : 
                        <img width="26px" src={iconPath[tile.my_reaction]} />
                      : 
                        (props.post_my_reaction == '') ?
                        <img width="26px" src={iconPath['DEFAULTREACTION']} /> : 
                        <img width="26px" src={iconPath[props.post_my_reaction]} />
                    }
                  </div>
                  <a className="view_all_like" href={void(0)}>
                     {
                      (props.imageList.media_details.length > 1) ?
                       tile.total_reaction
                       : props.post_total_reaction
                      }
                  </a>  
                </Link>
                </div>
                <div className="col-lg-4">
                  <Link to={ (props.imageList.media_details.length == 1) ? `/post/${encrypt(props.feed_id)}` : `/media/${encrypt(tile.gallery_id)}`}>
                  <div className="btn-toolbar">
                    <img width="26px" src={iconPath['FEEDCOMMENT']}/>
                  </div>
                  <a className="view_all_like" href={void(0)}>
                      {
                        (props.imageList.media_details.length > 1) ?
                        tile.total_comment
                        : props.post_total_comment
                      }
                  </a> 
                 </Link>
                </div>
                <div className="col-lg-4">
                  <Link to={ (props.imageList.media_details.length == 1) ? `/post/${encrypt(props.feed_id)}` : `/media/${encrypt(tile.gallery_id)}`} className="checkApp">
                    <div className="btn-toolbar">
                      <img width="26px" src={iconPath['FEEDSHARE']}/>
                    </div>
                    <a className="view_all_like" href={void(0)}>
                        {
                          (props.imageList.media_details.length > 1) ?
                          tile.total_share
                          : props.post_total_share
                        }
                    </a> 
                  </Link>
                </div>
              </div>
            </div>
            :
            <div className={(props.currentActiveImage == index) ? "item active" : "item" } key={tile.gallery_id}>  
              <video controls className="carousal-video" controlsList="nodownload">
                 <source src={tile.media_link} type="video/mp4" 
                 onError = {(e) => {
                    e.target.src = iconPath['BREAKIMAGE']
                 }}/>
                 Your browser does not support the video tag.
              </video> 
              <div className="modal_actions_icons">
                <div className="col-lg-4">
                  <div className="btn-toolbar">
                    {
                      (props.imageList.media_details.length > 1) ?
                        (tile.my_reaction == '') ?
                        <img width="26px" src={iconPath['DEFAULTREACTION']} /> : 
                        <img width="26px" src={iconPath[tile.my_reaction]} />
                      : 
                        (props.post_my_reaction == '') ?
                        <img width="26px" src={iconPath['DEFAULTREACTION']} /> : 
                        <img width="26px" src={iconPath[props.post_my_reaction]} />
                    }
                    
                  </div>
                  
                  <a className="view_all_like" href={void(0)}>
                     {
                      (props.imageList.media_details.length > 1) ?
                       tile.total_reaction
                       : props.post_total_reaction
                      }
                  </a>  
                </div>
                <div className="col-lg-4">
                  <div className="btn-toolbar">
                    <img width="26px" src={iconPath['FEEDCOMMENT']}/>
                  </div>
                  <a className="view_all_like" href={void(0)}>
                      {
                        (props.imageList.media_details.length > 1) ?
                        tile.total_comment
                        : props.post_total_comment
                      }
                    
                  </a> 
                </div>
                <div className="col-lg-4 checkApp" >
                  <div className="btn-toolbar">
                    <img width="26px" src={iconPath['FEEDSHARE']}/>
                  </div>
                  <a className="view_all_like" href={void(0)}>
                      {
                        (props.imageList.media_details.length > 1) ?
                        tile.total_share
                        : props.post_total_share
                      }
                     
                  </a> 
                </div>
              </div>
            {/* <ReactPlayer 
                      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                      url={tile.media_link} controls key={tile.gallery_id} 
                      onClick={()=>setImageindex(index)}
            /> */}
            </div>
          )
         
        }) 
        : null
      }
    </div>


    <a className="left carousel-control" href="#myCarousel" data-slide="prev">
      <i className="fa fa-arrow-left" aria-hidden="true"></i>
    </a>
    <a className="right carousel-control" href="#myCarousel" data-slide="next">
    <i className="fa fa-arrow-right" aria-hidden="true"></i>
    </a>
  </div>

  );
}
